export enum OlympCaptchaDestination {
  Login = 'login',
  Registration = 'register',
  ResetPassword = 'reset_password',
  SmsSend = 'sms_send',
}

export enum OlympCaptchaType {
  Recaptcha = 'recaptcha',
  RecaptchaChallenge = 'recaptcha_challenge',
}

export interface OlympCaptchaDto {
  destinations: OlympCaptchaDestination[];
  types: {
    type: OlympCaptchaType;
    key: string;
    version: string;
  }[];
}
